import NewsItem from './NewsItem'
import './NewsItem.css'

export default NewsItem



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/NewsItem/index.js